import { withTheme } from '@material-ui/core/styles';
import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = withTheme(styled.div`
  box-shadow: 0 0.1rem 0.8rem 0 rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.4);

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 1rem;

    border-bottom: 1px solid rgba(0, 0, 0, 0.4);

    color: ${({ theme }) => theme.palette.primary.main};

    .title {
      display: flex;
      align-items: center;
      margin-right: 1.5rem;

      svg {
        font-size: 3.2rem;
        margin-right: 0.5rem;
      }

      h1 {
        font-size: 1.4rem;
        max-width: 19rem;
        line-height: 1;
      }
    }

    @media (max-width: 768px) {
      padding: 0.75rem;

      .title {
        margin-right: 1rem;

        svg {
          font-size: 3rem;
        }

        h1 {
          font-size: 1.4rem;
          max-width: 15rem;
        }
      }
    }
  }
`);

export const Content = styled.div`
  padding: 1rem;

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

export const MyForm = styled(Form)`
  display: flex;
  flex-direction: column;

  border: 1px solid rgba(0, 0, 0, 0.2);

  padding: 1.5rem;

  .buttons {
    border-top: 1px solid rgba(0, 0, 0, 0.2);

    padding-top: 1.5rem;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      margin-left: 1rem;
    }
  }
`;
